import { API_URL } from '@shared/constants/config';
import userSettingsController from '@shared/controllers/UserSettingsController';

import { Client } from '@stomp/stompjs';

/** Полностью отказались от SockJS; используем нативный WebSocket-URL */
class ConnectStompClient {
  constructor(endpoint, attempts, retryInterval, newNotification, setUnReadNotifications) {
    this.endpoint = endpoint;
    this.attempts = attempts;
    this.retryInterval = retryInterval;
    this.newNotification = newNotification;
    this.setUnReadNotifications = setUnReadNotifications;
    this.stompClient = null;

    this.connect();
  }

  connect() {
    this.attempts -= 1;

    if (this.attempts <= 0) {
      console.warn('STOMP-подключения исчерпали лимит попыток.');
      return;
    }

    // Получаем порт из переменной окружения, если она определена
    const websocketPort = import.meta.env?.PUBLIC_WEBSOCKET_PORT;
    const portSuffix = websocketPort ? `:${websocketPort}` : '';

    const brokerURL =
      (window.location.hostname === 'localhost'
        ? 'wss://kampus.local/api/v1/ws'
        : `wss://${new URL(API_URL).host}${portSuffix}/api/v1/ws`) + `?access_token=${this.endpoint}`;

    this.stompClient = new Client({
      brokerURL,
      reconnectDelay: this.retryInterval,
      debug: () => null,

      onConnect: () => {
        console.log('STOMP подключён:', brokerURL);

        /* публичные нотификации */
        this.stompClient.subscribe('/topic/notifications', frame => this.handleNotification(JSON.parse(frame.body)[0]));

        /* список непрочитанных */
        this.stompClient.subscribe('/user/queue/notifications', frame => {
          const list = JSON.parse(frame.body);
          if (list.length) this.handleNotification(list[0]);
          this.setUnReadNotifications(list);
        });

        /* одиночная персональная */
        this.stompClient.subscribe('/user/queue/notification', frame => {
          const notif = JSON.parse(frame.body);
          this.handleNotification(notif);
          this.setUnReadNotifications(notif, true);
        });

        /* запросим последние 99 штук */
        this.stompClient.publish({
          destination: '/app/notifications/fetch',
          body: JSON.stringify({ page: 0, size: 99 }),
        });
      },

      onStompError: frame => {
        console.error('STOMP ошибка:', frame.headers['message'], frame.body);
        setTimeout(() => this.connect(), this.retryInterval);
      },

      onWebSocketClose: () => {
        console.warn('WebSocket закрыт, повтор через', this.retryInterval);
        setTimeout(() => this.connect(), this.retryInterval);
      },
    });

    this.stompClient.activate();
  }

  handleNotification(notification) {
    if (!notification) return;

    const id = notification.id || notification._id || `${notification.type || 'notification'}_${Date.now()}`;

    if (userSettingsController.shouldHideNotification(id)) return;

    userSettingsController.incrementNotificationCount(id);
    try {
      this.newNotification(notification);
    } catch (e) {
      console.error('Не удалось показать уведомление', e);
    }
  }

  disconnect() {
    this.stompClient?.deactivate();
  }
}

export default ConnectStompClient;
